module.exports = __webpack_public_path__ + "static/media/icon-arrow-black.c01ac63c.svg";